import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreatetRiesgoEmbarazoLactancia = () => {
  const [loadingRiesgoEmbarazoLactancia, setLoadingCreateRiesgoEmbarazoLactancia] = useState(false);
  const [successRiesgoEmbarazoLactancia, setSuccessCreateRiesgoEmbarazoLactancia] = useState(false);
  const [errorRiesgoEmbarazoLactancia, setErrorCreateRiesgoEmbarazoLactancia] = useState(null);
  const [dataRiesgoEmbarazoLactancia, setDataRiesgoEmbarazoLactancia] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )



  //CREATE
  const createRiesgoEmbarazoLactancia = async (userId:string, data: any ,_cb?:(data:any)=>void) => {
    setLoadingCreateRiesgoEmbarazoLactancia(true);
    setSuccessCreateRiesgoEmbarazoLactancia(false);
    setErrorCreateRiesgoEmbarazoLactancia(null);

    apiRecord.newSolicitudReconocimientoREL(userId, data).then((res: any) => {
      setLoadingCreateRiesgoEmbarazoLactancia(false);
      setSuccessCreateRiesgoEmbarazoLactancia(true);
      setDataRiesgoEmbarazoLactancia(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateRiesgoEmbarazoLactancia(false);
      setErrorCreateRiesgoEmbarazoLactancia(err.response.data)
    })
  }




  return {
    createRiesgoEmbarazoLactancia,
    loadingRiesgoEmbarazoLactancia,
    successRiesgoEmbarazoLactancia,
    errorRiesgoEmbarazoLactancia,
    dataRiesgoEmbarazoLactancia
  }

}

export default useCreatetRiesgoEmbarazoLactancia;
